import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Metamasksign from "../Pages/Metamasksign/Metamasksign";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Signmetamasktheme() {
  return (
    <>
      <Header />
      <Metamasksign />
      <Footer />
    </>
  );
}
